import { Row as AntRow } from 'antd'
import type { ComponentProps } from 'react'

type AntRowProps = ComponentProps<typeof AntRow>

export interface AppRowProps extends AntRowProps {}

export const AppRow = (props: AppRowProps) => <AntRow {...props} />
